module.exports = __webpack_public_path__ + "media/images/wallet/wallet-img-9c7e222aee349a4dfb2982942271c1b5.png";